import { render, staticRenderFns } from "./AppPage.vue?vue&type=template&id=47e75e6b&scoped=true&"
import script from "./AppPage.vue?vue&type=script&lang=ts&"
export * from "./AppPage.vue?vue&type=script&lang=ts&"
import style0 from "./AppPage.vue?vue&type=style&index=0&id=47e75e6b&prod&lang=scss&scoped=true&"
import style1 from "./AppPage.vue?vue&type=style&index=1&id=47e75e6b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e75e6b",
  null
  
)

export default component.exports